import { Helmet } from "react-helmet-async"
import { useOutletContext } from "react-router"
import {
	OAuthAppRequests,
	TOAuthIntegration,
} from "../../../../../Integrations"

export default function OAuthIntegrationRequestsPage() {
	const context = useOutletContext<{ integration: TOAuthIntegration }>()

	return (
		<>
			<Helmet>
				<title>Requests | OAuth App</title>
			</Helmet>
			<OAuthAppRequests integration={context.integration} />
		</>
	)
}
